import script from "./AtividadeObjetivosInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadeObjetivosInput.vue?vue&type=script&setup=true&lang=js"

import "./AtividadeObjetivosInput.vue?vue&type=style&index=0&id=41815357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41815357"]])

export default __exports__